<template>
  <div class="grid grid-cols-6 gap-2 w-full" @paste="pasteInput">
    <input
      v-for="(_, index) in code"
      :key="index"
      :ref="(el) => (inputs[index] = el as HTMLInputElement)"
      v-model="code[index]"
      type="text"
      maxlength="1"
      min="0"
      max="9"
      pattern="[0-9]{1}"
      class="rounded h-14 text-center outline-none duration-200 border focus:ring-2 focus:ring-thm focus:ring-offset-2 focus:border-bgr-400"
      :class="invalid ? 'border-err' : 'border-bgr-300'"
      @input="onInput(index, $event)"
      @keydown.backspace="onBackspace(index)"
    />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  initialCode?: string
  invalid: boolean
}>()

const emit = defineEmits(['codeEntered', 'change'])

const inputs = ref<HTMLInputElement[]>([])
const code = ref<string[]>(Array(6).fill(''))

onMounted(() => {
  // If the code is set in the props, paste it into the inputs and submit the form, if all inputs are filled
  if (props.initialCode) {
    pasteCodeFrom(props.initialCode)
  }
})

function onInput(index: number, event: Event) {
  const input = event.target as HTMLInputElement
  const { value } = input

  if (value && index < 5) {
    inputs.value[index + 1]?.focus()
  }
  emit('change', code.value.join(''))
}

function onBackspace(index: number) {
  if (index > 0 && !code.value[index]) {
    inputs.value[index - 1]?.focus()
  }
  emit('change', code.value.join(''))
}

// Paste the input from the clipboard into the inputs
function pasteInput(event: ClipboardEvent) {
  const { clipboardData } = event
  if (clipboardData) {
    const pastedData = clipboardData.getData('text')
    pasteCodeFrom(pastedData)
  }
}

// This function checks how many inputs are filled with values and returns the count
function numberOfFilledInputs() {
  return code.value.length
}

// Paste the code from the props into the inputs
function pasteCodeFrom(from: string) {
  code.value = from.slice(0, 6).split('')

  // Focus the last input field
  const length = numberOfFilledInputs()
  inputs.value[length - 1].focus()

  // possibility to submit automatically
  if (length === 6) {
    submit()
  }
}

// submit the code
function submit() {
  emit('codeEntered', code.value.join(''))
}
</script>

<style></style>
